import { render, staticRenderFns } from "./ModalRemoveAutopayWallet.vue?vue&type=template&id=4c2e878c&scoped=true&"
import script from "./ModalRemoveAutopayWallet.vue?vue&type=script&lang=js&"
export * from "./ModalRemoveAutopayWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2e878c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c2e878c')) {
      api.createRecord('4c2e878c', component.options)
    } else {
      api.reload('4c2e878c', component.options)
    }
    module.hot.accept("./ModalRemoveAutopayWallet.vue?vue&type=template&id=4c2e878c&scoped=true&", function () {
      api.rerender('4c2e878c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/editors/ModalRemoveAutopayWallet.vue"
export default component.exports